

import EA from '../helpers/init';
import gsap from 'gsap';

export default EA.Methods.footerAnimFade = ($this) => {
    let didRun = false;

    const initAndPlay = () => {
        if (didRun) return;
        didRun = true;

        let offset = $this.getAttribute('data-offset') || '30%';
        const fadeInEls = $this.querySelectorAll('.anim-fade-up');

        if (window.innerWidth < 600) offset = '30%';

        // Settings (keep your adaptive stagger idea)
        let stagger = 0.35;
        const minStagger = 0.17;
        const decrement = -0.03;
        const childrenCount = fadeInEls.length;

        gsap.config({ nullTargetWarn: false });

        if (childrenCount > 4) {
            for (let i = 3; i < childrenCount; i++) {
                stagger += decrement;
                stagger = Math.max(minStagger, stagger);
            }
        }

        const onDone = () => {
            $this.classList.add('anims-done');
            // Clear any inline styles we set (you can also rely on clearProps below)
            fadeInEls.forEach((el) => (el.style = ''));
        };

        // Initial state
        gsap.set(fadeInEls, { y: 20, opacity: 0 });

        // One timeline = deterministic order, no missed elements.
        gsap.timeline({ defaults: { ease: 'power3.out' }, onComplete: onDone })
            .to(fadeInEls, {
                y: 0,
                opacity: 1,
                duration: 0.75,
                stagger: stagger,
                clearProps: 'y,opacity',
                overwrite: 'auto',
            });
    };

    // Trigger once when footer enters viewport.
    const io = new IntersectionObserver(
        (entries) => {
            // Multiple entries can come through; trigger if any intersects.
            if (!entries.some((e) => e.isIntersecting)) return;
            io.disconnect();
            initAndPlay();
        },
        {
            root: null,
            threshold: 0,          // fires when ~1px is visible (default behavior) [web:12]
            rootMargin: '100px 0px 0px 0px', // start a bit early to avoid “late” reveals [web:9]
        }
    );

    io.observe($this);
};
